import { useLocation } from 'react-router-dom';
import FeedbackTemplatePage from '../../components/FeedbackTemplatePage/FeedbackTemplatePage';

const ErrorPage = () => {
    const location = useLocation();

    return (
        <FeedbackTemplatePage
            status={location.state?.status}
            title={location.state?.title}
            subTitle={location.state?.subTitle}
            showIcon={true}
        />
    );
};

export default ErrorPage;
